import { Alert } from 'antd';
import { FormButton } from 'common/components';
import { FileAddOutlined, TableOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { toggleHelpCenter } from '@redux/global/actions';

import WizardContentBox from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardContentBox';
import WizardTitle from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardTitle';
import { WizardDescription } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardDescription';
import { useWizard } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';
import { STEP_TYPES } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepConstants';

import 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/styles/IntroStep.less';

const IntroStep = () => {
  const dispatch = useDispatch();
  const { handleGoToStep, handleContinue, actions } = useWizard();

  const handleBypassClick = () => {
    actions.setBypassed(true);
    handleGoToStep(STEP_TYPES.PRODUCT_GRID_QUESTION);
  };

  return (
    <WizardContentBox className='product-wizard-intro'>
      <section className='product-wizard-intro__recapture'>
        <div>
          <WizardTitle title='Submitting Items for Recapture' />
          <WizardDescription>
            You can submit items for recapture by clicking on the{' '}
            <strong>Grid/Template</strong> button below. Alternately, recaptures
            can be done from the <strong>Product screen</strong> within the
            platform. Please see the guide in the <strong>Help Center</strong>.
          </WizardDescription>
        </div>
        <FormButton
          text='View Help Center'
          type='default'
          icon={false}
          className='product-wizard-intro__help'
          onClick={() => dispatch(toggleHelpCenter(true))}
        />
      </section>

      <section className='product-wizard-intro__capture'>
        <WizardTitle title='Submitting New Items for Capture' />
        <div className='product-wizard-intro__options'>
          <div className='product-wizard-intro__option product-wizard-intro__option--guided'>
            <div className='product-wizard-intro__card-top'>
              <div className='product-wizard-intro__icon'>
                <FileAddOutlined />
              </div>
              <span className='product-wizard-intro__recommended'>
                Recommended
              </span>
            </div>
            <div className='product-wizard-intro__copy'>
              <WizardDescription>
                If you are not familiar with the Product Upload Wizard or if your
                product is a <strong>“special product type”</strong>, click{' '}
                <strong>Continue</strong> and answer all the Wizard’s{' '}
                <strong>guided questions</strong>. The system will then tell you if
                using the <strong>Product Submission Grid</strong> or a{' '}
                <strong>Template</strong> best suits your needs and will populate
                the necessary fields in the determined submission method.
              </WizardDescription>
            </div>
            <FormButton
              text='Continue'
              icon={false}
              type='primary'
              className='product-wizard-intro__button'
              onClick={handleContinue}
            />
          </div>
          <div className='product-wizard-intro__option'>
            <div className='product-wizard-intro__card-top'>
              <div className='product-wizard-intro__icon'>
                <TableOutlined />
              </div>
            </div>
            <div className='product-wizard-intro__copy'>
              <WizardDescription>
                If you already know that you will be submitting your items for
                capture either by the <strong>Product Submission Grid</strong> or{' '}
                <strong>Template</strong>, click <strong>Grid/Template</strong>{' '}
                button to bypass the guided questions.
              </WizardDescription>
            </div>
            <FormButton
              text='Grid / Template'
              icon={false}
              type='default'
              className='product-wizard-intro__button'
              onClick={handleBypassClick}
            />
          </div>
        </div>
      </section>

      <Alert
        showIcon
        type='info'
        className='product-wizard-intro__notice'
        message={
          <>
            If your item is a <strong>“special product type”</strong> you{' '}
            <strong>MUST</strong> go through the Wizard’s guided questions for the
            product-specific required fields to populate in the Product Submission
            Grid. <em>(See Wizard question topics on the left for type examples.)</em>
          </>
        }
      />
    </WizardContentBox>
  );
};

export default IntroStep;
